module.exports = __webpack_public_path__ + "static/img/env13.5bd4572.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env13.png
// module id = 106
// module chunks = 4